/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-08-09 10:45:11
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyWidget } from "../BsyWidget";
import "./index.css";

import { BsyConfig } from "../../global/BsyConfig";
import BsySelect from "../BsySelect";
import BsyIconBtn from "../BsyIconBtn";
import BsyMsgBubble from "../BsyMsgBubble";
import BsyFieldsSelectPane from "../BsyFieldsSelectPane";
import { BsyUtils } from "../../utils/Utils";
import { BsyFilterApp } from "../filterField/BsyFilterApp";
import { BsyFilterEntry } from "../filterField/BsyFilterEntry";

export default class BsyFilterPane extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-filter-pane",
    fields: [],
    entryList: {},
    forms: [],
    authGroupId: null,
    hasAggregateTable: !1,
    attributeFields: ["creator", "updateTime", "createTime"],
    needFormName: 0,
    supportCurrentUser: !0,
    supportCurrentDept: !0,
    supportSelectEmpty: !0,
    supportSubform: !0,
    dataManager: !1,
    flowType: "",
    isAllNode: false,
    hasDefault: false, //用于筛选条件下拉框组件加载数据的时候，后端使用
    hasMethods: !0,
    hasRelation: !1,
    hasFlowFilters: !1,
    onStopEdit: null,
    modal: !0,
    hasPin: false,
    hasHeader: false,
    filterSticky: false,
    filterTopSticky: false,
    hasfilterSticky: true,
    hasfilterTopSticky: true,
    rel: "and",
    mode: "internalFlow",
    hasSticky: false,
    cond: [],
  };
  constructor(props) {
    super(props);
    this.element = React.createRef();
    this.contextMap = {};
    this.filter = {};
    this.filterMap = {};
    for (let index = 0; index < props.cond.length; index++) {
      let data = { ...props.cond[index] };
      this.filterMap[data.field] = { ...data };
      delete data.defaultConfig;
      this.filter[data.field] = { ...data };
    }

    this.state = {
      availableFields: BsyConfig().LimitFields.filter,
      text4add: React.language("field.linkFilter.add"),
      ...props,
      fields: this.initFieid(props.entryList),
      flowType: props.mode === "dataload" ? undefined : props.flowType,
    };

    this.entryIdCC = 0;
    this.appIdCC = 0;
  }

  initFieid = (entryList) => {
    let that = this;
    let fields = [];
    BsyUtils.forEach(entryList, (a1, b1) => {
      if (b1.fields) {
        for (let i = 0; i < b1.fields.length; i++) {
          if (b1.fields[i].type === "subform") {
            for (let j = 0; j < b1.fields[i].items.length; j++) {
              let name = [b1.fields[i].name, b1.fields[i].items[j].name].join(
                "."
              );
              if (that.filter[name]) {
                fields.push({
                  ...b1.fields[i].items[j],
                  id: b1.fields[i].id,
                  appId: b1.fields[i].appId,
                  entryId: b1.fields[i].entryId,
                  formId: b1.fields[i].formId,
                  designAppId: b1.fields[i].designAppId,
                  designEntryId: b1.fields[i].designEntryId,
                  designWidgetName: b1.fields[i].designWidgetName,
                  designSubform: b1.fields[i].name,
                  name: name,
                  text: [b1.fields[i].text, b1.fields[i].items[j].text].join(
                    "."
                  ),
                });
              }
            }
          } else {
            if (that.filter[b1.fields[i].name]) {
              fields.push(b1.fields[i]);
            }
          }
        }
      }
    });
    console.log("fields", fields);
    return fields;
  };

  componentDidMount() {
    super.componentDidMount();
    const { appId, entryId } = this.props;
    if (appId && entryId) this.getEntryField();
  }

  getContext = (e) => {
    this.contextMap[e.options.widgetId] = e;
  };

  getFilterItemConfig = (config) => {
    const { authGroupId, flowType, mode } = this.state;
    let vdr = {
      appId: config.appId ? config.appId : undefined,
      entryId: config.id,
      designAppId: config.designAppId,
      designEntryId: config.designEntryId,
      designSubform: config.designSubform,
      designWidgetName: config.designWidgetName,
      fields: [
        {
          field: config.name,
          form: config.id,
          type: config.type,
        },
      ],
      type: BsyUtils._widget_dash_filter(config.type),
      rely: [],
      triggers: [],
      title: config.text || config.title,
      widgetId: config.name,
      height: 6,
      method:
        (this.filter[config.name] && this.filter[config.name].method) ||
        BsyUtils.getDashDefaultFilterMethod(config.type),
      asyncResultKey: "items",
      defaultConfig: this._margedefaultConfig(this.filter[config.name]),
      onBeforeAsync: this.options.onBeforeAsync,
      sync:
        mode === "dataload"
          ? undefined
          : {
              url: "/data/distinct",
              data: {
                appId: config.appId || window.FX.STATIC.APPID,
                entryId: config.id,
                field: config.name,
                formId: config.id,
                flowType: flowType,
                hasLimit: true,
                limit: 100,
                skip: 0,
                authGroupId: authGroupId,
                popupFormPath: [],
                type: config.type,
                jsplatform: "React",
              },
            },
    };
    if (config.subform) {
      vdr.fields = [
        {
          subform: config.subform,
          subField: config.name.split(".")[1],
          form: config.id,
          type: config.type,
        },
      ];
    }

    switch (config.type) {
      case "text": {
        vdr.valueMode = "item";
        break;
      }
      case "datetime": {
        vdr.format = config.format;
        // vdr.height = 9;
        switch (config.format) {
          case "yyyy-MM-dd HH:mm:ss": {
            vdr.type = "datetime_filter";
            break;
          }
          case "yyyy-MM-dd": {
            vdr.type = "date_filter";
            break;
          }
          case "yyyy-MM": {
            vdr.type = "datemonth_filter";
            break;
          }
          case "yyyy": {
            vdr.type = "dateyear_filter";
            break;
          }
          default: {
            vdr.format = "yyyy-MM-dd";
          }
        }

        break;
      }
      default: {
      }
    }
    return { ...vdr };
  };

  getValue = () => {
    const { rel, cond, appId, entryId } = this.state;
    return {
      rel,
      cond,
      appId,
      entryId,
    };
  };

  deleteFilterItem = (res) => {
    const { fields } = this.state;
    let cond = [];
    const newFields = fields.filter((d) => {
      let ret = d.name !== res.widgetId;
      if (!ret) {
        if (this.filterMap[res.widgetId]) delete this.filterMap[res.widgetId];
        if (this.filter[res.widgetId]) {
          delete this.filter[res.widgetId];
        }
        if (this.contextMap[res.widgetId]) {
          delete this.contextMap[res.widgetId];
        }
      } else {
        if (this.filter[d.name]) {
          cond.push(this.filter[d.name]);
        }
      }
      return ret;
    });
    this.setState(
      {
        fields: newFields,
        cond: cond,
      },
      () => {
        // this.props.onSetFieldFilter && this.props.onSetFieldFilter(this.getValue());
        this.props.onFilter &&
          this.props.onSetFieldFilter(
            {
              rel: this.state.rel,
              cond: [...cond],
              appId: this.state.appId,
              entryId: this.state.entryId,
            },
            true
          );
      }
    );
  };

  createFilterItem = (res) => {
    // console.log(res)

    res = this.getFilterItemConfig(res);

    let filterType = BsyUtils._widget_dash_filter(res.type);
    res.filterType = filterType;
    res.flowType = this.state.flowType;
    res.onBeforeAsync = this.options.onBeforeAsync;
    return (
      <div className="filter-item bsy-filter-base" key={res.widgetId}>
        <div
          className="remove-item"
          onClick={() => {
            this.deleteFilterItem(res);
          }}
        >
          <i className="icon-bsy-close-small"></i>
        </div>
        {BsyUtils.createWidget({
          ...res,
          getContext: this.getContext,
          onStopEdit: this.onFilterStopEdit,
        })}
      </div>
    );
  };

  _getComboCheckFilter = (t, e) => {
    let i = (e && e.items) || (e && e.value);
    let r = {
      type: t,
      hasEmpty: !!e?.hasEmpty,
      value: !BsyUtils.isObjectEmpty(i) ? BsyUtils.makeArray(i) : [],
      hasCurrentDept: !(!e || !e.hasCurrentDept),
      hasCurrentUser: !(!e || !e.hasCurrentUser),
      hasCurrentSubDept: !(!e || !e.hasCurrentSubDept),
      hasCurrentParDept: !(!e || !e.hasCurrentParDept),
    };
    if (e) {
      r.parentDepts = e.parentDepts ? BsyUtils.makeArray(e.parentDepts) : [];
    }
    switch (r.type) {
      case "flow_chargers":
      case "user":
      case "usergroup": {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        break;
      }
      case "deptgroup":
      case "dept": {
        delete r.hasCurrentUser;
        break;
      }
      default: {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        delete r.parentDepts;
        delete r.hasCurrentUser;
        break;
      }
    }
    return r;
  };

  _updateFilter = (t, e, i) => {
    let a = e.fields[0],
      n = {};
    this.filter[t] = this.filter[t] || {};
    n.method = e.method || BsyUtils.getDashDefaultFilterMethod(a && a.type);
    n.value = i;
    n.valueMode = e.valueMode;
    n.fields = e.fields;
    n.field = t;
    n.entryId = e.entryId;
    n.fields[0].formId = e.entryId;
    n.hasEmpty = n.method === "empty";
    if (a) {
      switch (a.type) {
        case "text":
        case "radiogroup":
        case "combo":
        case "sn":
          n = { ...n, ...this._getComboCheckFilter("text", i) };
          break;
        case "textarea":
          n.type = "textarea";
          let s = i && i.items ? i.items[0] : i && i.value;
          n.value = s ? BsyUtils.makeArray(s) : [];
          break;
        case "combocheck":
        case "checkboxgroup":
          n = { ...n, ...this._getComboCheckFilter("combocheck", i) };
          break;
        case "number":
          n.type = "number";
          if (n.method === "empty" || n.method === "not_empty") {
            n.value = [];
          } else {
            i &&
              (n.value = BsyUtils.isEmpty(i.value)
                ? [i.min, i.max]
                : [i.value]);
          }
          break;
        case "datetime":
          n.type = "datetime";
          let o = "yyyy-MM-dd";
          switch (e.type) {
            case "datetime_filter": {
              o = "yyyy-MM-dd HH:mm:ss";

              break;
            }
            case "datemonth_filter": {
              o = "yyyy-MM";
              break;
            }
            case "dateyear_filter": {
              o = "yyyy";
              break;
            }
            default:
          }
          // let o = "datetime_filter" === e.type ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
          // i && i.value ? n.value = [BsyUtils.date2Str(new Date(i.value), o)] : i && i.mode ? n.value = [i] : n.value = [i && i.min ? BsyUtils.date2Str(new Date(i.min), o) : null, i && i.max ? BsyUtils.date2Str(new Date(i.max), o) : null];

          if (i && i.value) {
            n.value = [typeof i.value === 'string' ? i.value : BsyUtils.date2Str(new Date(i.value), o)];
          } else {
            if (i && i.mode) {
              n.value = [i];
            } else {
              n.value = [
                i && i.min ? typeof i.min === 'string' ? i.min : BsyUtils.date2Str(new Date(i.min), o) : null,
                i && i.max ? typeof i.max === 'string' ? i.max : BsyUtils.date2Str(new Date(i.max), o) : null,
              ];
            }
          }

          break;
        case "address":
        case "location":
          n.type = "address";
          n.value = i ? [i.province, i.city, i.district] : [];
          break;
        case "user":
        case "usergroup":
        case "dept":
        case "deptgroup":
        case "flowcreator":
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flow_chargers":
          n.type = "flow_chargers";
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flowstate":
        case "flowState":
          n.type = "flowstate";
          let e1 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e1) ? BsyUtils.makeArray(e1) : [];
          break;
        case "flowdecision":
          n.type = "flowdecision";
          let e2 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e2) ? BsyUtils.makeArray(e2) : [];
          break;
        case "backflowid":
          n.type = "backflowid";
          n.value = i;
          break;
        case "flownode":
          n.type = "flownode";
          n.value = i;
          break;
        case "upload":
        case "image":
          n.type = a.type;
          n.value = [];
          break;
        case "signature":
          n.type = "signature";
          n.value = [];
          break;
        case "assist_prostatus":
          n.type = "assist_prostatus";
          let e4 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e4) ? BsyUtils.makeArray(e4) : [];
          break;
        case "assist_flowid":
          n.type = "assist_flowid";
          let e3 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e3) ? BsyUtils.makeArray(e3) : [];
          break;
        default:
          break;
      }
    }
    this.filter[t] = { ...this.filter[t], ...n };
  };

  onFilterStopEdit = (t, e) => {
    let that = this;
    let a = t.value || [];
    let method = t.method;
    let valueMode = t.valueMode;
    this._updateFilter(
      e.widgetId,
      {
        ...e,
        ...{
          method: method,
          value: a,
          hasEmpty: method === "empty",
          valueMode: valueMode,
        },
      },
      a
    );
    this.filterMap[e.widgetId] = this.filter[e.widgetId] || {};
    this.filterMap[e.widgetId].defaultConfig = this._margedefaultConfig(
      this.filter[e.widgetId]
    );
    let d = [];
    BsyUtils.forEach(this.state.fields, (index, data) => {
      if (data && that.filter[data.widgetId || data.name])
        d.push({ ...that.filter[data.widgetId || data.name] });
    });
    // console.log('d111', JSON.stringify(d))
    that.setState(
      {
        cond: JSON.parse(JSON.stringify(d)),
      },
      () => {
        // that.props.onSetFieldFilter && that.props.onSetFieldFilter(this.getValue());
        // console.log('d2222', JSON.stringify(this.state.cond))
        this.props.onFilter &&
          this.props.onSetFieldFilter(
            {
              rel: this.state.rel,
              cond: [...this.state.cond],
              appId: this.state.appId,
              entryId: this.state.entryId,
            },
            true
          );
      }
    );
  };
  //转换默认值的格式
  _margedefaultConfig = (filter) => {
    if (!filter || !BsyUtils.checkFilterValid(filter)) {
      return {};
    }
    let filterType = BsyUtils._widget_dash_filter(filter.type);
    switch (filterType) {
      case "backflowid_filter":
      case "flownode_filter": {
        return {
          value: filter.value,
        };
        break;
      }
      case "flowcreator_filter":
      case "dept_filter":
      case "user_filter":
      case "text_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK:
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE: {
            return {
              value: filter.value[0],
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.IN:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,
              items: [...filter.value],
            };
            break;
          }
          default:
        }
        break;
      }
      case "textarea_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK: {
            return {
              value: filter.value[0],
            };
            break;
          }
          default:
        }
        break;
      }
      case "number_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GT:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LT:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0],
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0],
              max: filter.value[1],
            };
            break;
          }
          default:
        }
        break;
      }
      case "flowdecision_filter": {
        if (filter && filter.value) {
          return {
            value: filter.value,
          };
        }
        break;
      }

      case "usergroup_filter":
      case "deptgroup_filter":
      case "flow_chargers_filter":
      case "combocheck_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.IN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,

              items: [...filter.value],
            };
            break;
          }
          default:
        }
        break;
      }
      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0]
                ? filter.value[0]
                : null,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0] ? filter.value[0] : null,
              max: filter.value[1] ? filter.value[1] : null,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.FM: {
            return filter.value;
            break;
          }
          default:
        }
        break;
      }

      case "location_filter":
      case "address_filter":
      case "address_province_filter":
      case "address_city_filter":
      case "address_district_filter":
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              province: filter.value[0],
              city: filter.value[1],
              district: filter.value[2],
            };
            break;
          }
          default:
        }
        break;
      default: {
        if (filter && filter.value) {
          return {
            value: filter.value[0],
          };
        }
        break;
      }
    }
  };

  getDefaultCache = () => {
    let that = this;
    let d = [];
    BsyUtils.forEach(that.state.fields, (index, data) => {
      if (!that.filter[data.widgetId || data.name]) {
        d.push({
          field: data.widgetId || data.name,
          fields: [
            {
              field: data.widgetId || data.name,
              form: that.state.formId,
              formId: that.state.formId,
              type: data.type,
            },
          ],
          hasCurrentDept: false,
          hasCurrentParDept: false,
          hasCurrentSubDept: false,
          hasCurrentUser: false,
          hasEmpty: false,
          method: BsyUtils.getDashDefaultFilterMethod(data.type),
          type: data.type,
          parentDepts: [],
          value: [],
        });
      } else {
        d.push(that.filter[data.widgetId || data.name]);
      }
    });
    that.setState(
      {
        cond: [...d],
      },
      () => {
        // that.props.onSetFieldFilter && that.props.onSetFieldFilter(this.getValue());
        this.props.onFilter &&
          this.props.onSetFieldFilter(
            {
              rel: this.state.rel,
              cond: [...d],
              appId: this.state.appId,
              entryId: this.state.entryId,
            },
            true
          );
      }
    );
  };

  //重置条件值
  reset = () => {
    let that = this;
    let dda = [];
    // BsyUtils.forEach(this.filter, (key, res) => {
    //     // delete this.filterMap[key].defaultConfig;
    //     res.value = null;
    //     res.hasCurrentDept = false;
    //     res.hasCurrentParDept = false;
    //     res.hasCurrentSubDept = false;
    //     res.hasCurrentUser = false;
    //     res.hasEmpty = false;
    //     res.parentDepts = [];
    //     dda.push(res);
    //     that.contextMap[key].setValue(null, res.method);
    // })
    // let d = [];
    // BsyUtils.forEach(this.state.fields, (index, data) => {
    //     if (data && that.filter[data.widgetId || data.name])
    //         d.push(that.filter[data.widgetId || data.name]);
    // })
    this.entryIdCC++;
    this.appIdCC++;
    this.filter = {};
    that.setState(
      {
        cond: [],
        fields: [],
        appId: null,
        entryId: null,
      },
      () => {
        this.props.onFilter &&
          this.props.onFilter(
            {
              rel: this.state.rel,
              cond: [],
            },
            true
          );
      }
    );
  };

  getEntryField = () => {
    const { appId, entryId, flowType } = this.state;

    // /dashboard/app/5431754b99e41190507cb129/workflow/get_form_fields

    React.axios(`/dashboard/app/${appId}/workflow/get_form_fields`, {
      appId: appId,
      entryId: entryId,
      formId: entryId,
    }).then((res1) => {
      let entryList = {
        [entryId]: {
          id: entryId,
          fields: [...res1.data],
        },
      };

      switch (flowType) {
        case "todo":
          entryList[entryId].fields.push({
            name: "flowcreator",
            type: "flowcreator",
            text: React.language("flow.creator"),
          });
          entryList[entryId].fields.push({
            name: "createTime",
            type: "datetime",
            text: React.language("flow.createTime"),
          });
          entryList[entryId].fields.push({
            name: "flowNode",
            type: "flownode",
            text: React.language("flow.node.current"),
          });
          entryList[entryId].fields.push({
            name: "backflowid",
            type: "backflowid",
            text: React.language("flow.action.back") + React.language("node"),
          });
          break;
        case "cc":
          entryList[entryId].fields.push({
            name: "flowcreator",
            type: "flowcreator",
            text: React.language("flow.creator"),
          });
          entryList[entryId].fields.push({
            name: "createTime",
            type: "datetime",
            text: React.language("flow.createTime"),
          });
          entryList[entryId].fields.push({
            name: "flowNode",
            type: "flownode",
            text: React.language("flow.node"),
          });
          break;
        case "transactors":
          entryList[entryId].fields.push({
            name: "flowState",
            type: "flowstate",
            text: React.language("field.flowState"),
          });
          entryList[entryId].fields.push({
            name: "flowcreator",
            type: "flowcreator",
            text: React.language("flow.creator"),
          });
          entryList[entryId].fields.push({
            name: "createTime",
            type: "datetime",
            text: React.language("flow.createTime"),
          });
          entryList[entryId].fields.push({
            name: "flowNode",
            type: "flownode",
            text: React.language("flow.node.current"),
          });
          break;
        case "create":
          entryList[entryId].fields.push({
            name: "flowState",
            type: "flowstate",
            text: React.language("field.flowState"),
          });
          entryList[entryId].fields.push({
            name: "createTime",
            type: "datetime",
            text: React.language("flow.createTime"),
          });
          entryList[entryId].fields.push({
            name: "flowNode",
            type: "flownode",
            text: React.language("flow.node.current"),
          });
          break;
        default:
          entryList[entryId] = [];
      }
      this.setState({
        fields: this.initFieid(entryList),
        entryList,
      });
    });
  };

  renderAppField = () => {
    const { appId, entryId, mode, corpId } = this.state;

    let appConfig = {
      fields: [
        {
          field: "appId",
          form: null,
          type: "text",
        },
      ],
      type: "appid_filter",
      rely: [],
      triggers: [],
      title: React.language("app"),
      widgetId: "appId",
      height: 6,
      method: "eq",
      mode: mode,
      defaultConfig: appId,
      corpId: corpId,
      onStopEdit: (val) => {
        this.entryIdCC++;
        this.filter = {};
        this.setState(
          {
            appId: val.value,
            cond: [],
            fields: [],
            entryId: null,
          },
          () => {
            this.props.onFilter &&
              this.props.onSetFieldFilter(
                {
                  rel: this.state.rel,
                  cond: [...this.state.cond],
                  appId: this.state.appId,
                  entryId: this.state.entryId,
                },
                true
              );
          }
        );
      },
    };
    let entryConfig = {
      appId: appId,
      fields: [
        {
          field: "entryId",
          form: null,
          type: "text",
        },
      ],
      type: "entry_filter",
      rely: [],
      triggers: [],
      title: React.language("form"),
      widgetId: "entryId",
      height: 6,
      flowType: this.options.flowType || "todo",
      method: "eq",
      defaultConfig: entryId,
      corpId: corpId,
      onStopEdit: (val) => {
        this.filter = {};
        this.setState(
          {
            entryId: val.value,
            cond: [],
            fields: [],
          },
          () => {
            this.getEntryField();
            this.props.onFilter &&
              this.props.onSetFieldFilter(
                {
                  rel: this.state.rel,
                  cond: [...this.state.cond],
                  appId: this.state.appId,
                  entryId: this.state.entryId,
                },
                true
              );
          }
        );
      },
    };

    return (
      <>
        <div
          className="filter-item bsy-filter-base"
          key={"appId" + this.appIdCC}
        >
          <BsyFilterApp {...appConfig} />
        </div>
        {
          //表单
          appId ? (
            <div
              className="filter-item bsy-filter-base"
              key={"entryId" + this.entryIdCC}
            >
              <BsyFilterEntry {...entryConfig} />
            </div>
          ) : (
            ""
          )
        }
      </>
    );
  };

  toFilterOption = (res) => {
    console.log("res", res);
    const { flowType, appId, entryId, mode } = this.state;
    if (!this.props.hasAppField) {
      return res;
    }

    if (!this.state.flowType) {
      return res;
    }

    let asyncResultKey = "items";
    let field = res.name || res.field;
    res.form = entryId;
    res.appId = appId;
    let item = {
      ...res,
      id: entryId,
      fields: res.fields ? res.fields : [res],
      field: field,
      appId: appId,
      type: res.type, // BsyUtils._widget_dash_filter(res.type),
      asyncResultKey,
      widgetId: field,
      formId: entryId,
      height: 6,
      defaultConfig: this._margedefaultConfig(res),
      title: res.text,
      sync:
        mode === "dataload"
          ? undefined
          : {
              url: "/data/distinct",
              data: {
                appId: appId,
                entryId: entryId,
                field: field,
                flowType: flowType,
                formId: entryId,
                hasLimit: true,
                limit: 100,
                popupFormPath: [],
                skip: 0,
                type: res.type,
              },
            },
    };
    switch (res.type) {
      case "flowcreator": {
        // item.asyncResultKey = 'creators';
        item.sync = {
          url: "/data/distinct",
          data: {
            appId: appId,
            entryId: entryId,
            field: "creator",
            flowType: flowType,
            formId: entryId,
            hasLimit: true,
            limit: 100,
            skip: 0,
            type: "user",
            
          },
        };
        break;
      }
      case "datetime": {
        item.format = res.format;

        switch (res.format) {
          // case 'yyyy-MM-dd HH:mm:ss': {
          //     item.type = "datetime_filter"
          //     break;
          // }
          // case 'yyyy-MM-dd': {
          //     item.type = "date_filter"
          //     break;
          // }
          // case 'yyyy-MM': {
          //     item.type = "datemonth_filter"
          //     break;
          // }
          // case 'yyyy': {
          //     item.type = "dateyear_filter"
          //     break;
          // }
          default: {
            item.format = "yyyy-MM-dd";
          }
        }

        break;
      }
      default:
    }
    return item;
  };

  render() {
    const {
      hasRelation,
      fields,
      rel,
      hasHeader,
      hasPin,
      filterSticky,
      filterTopSticky,
      appId,
      entryId,
      hasSticky,
    } = this.state;
    const { cssName } = this.options;
    let fieldsFilter = [];
    fields.map((res, key) => {
      if (res.name !== "label") {
        fieldsFilter.push(res);
      }
    });
    return (
      <div
        className={
          cssName +
          (filterTopSticky
            ? " filter-top-sticky"
            : filterSticky
            ? " filter-sticky"
            : "")
        }
        ref={this.element}
      >
        {
          // hasPin ? <div className="pin-btn" onClick={() => {
          //     this.props.onFilterSticky()
          // }}><i className={filterSticky ? "icon-unpin" : "icon-pin"}></i></div> : '' filterSticky
        }
        {hasSticky && (
          <>
            <div
              className={
                "pin-filter-top-sticky " + (filterTopSticky ? "sticky" : "")
              }
              onClick={() => {
                if (window.FX && window.FX.UI) {
                  window.FX.UI.closePopover();
                }
                this.props.onFilterTopSticky && this.props.onFilterTopSticky();
              }}
            >
              <i className={"icon-bsy-top-sticky "}></i>
              <span>{React.language("pin.top")}</span>
            </div>
            <div
              className={"pin-filter-sticky " + (filterSticky ? "sticky" : "")}
              onClick={() => {
                if (window.FX && window.FX.UI) {
                  window.FX.UI.closePopover();
                }
                this.props.onFilterSticky && this.props.onFilterSticky();
              }}
            >
              <i className={"icon-bsy-sticky "}></i>
              <span>{React.language("pin.right")}</span>
            </div>
          </>
        )}
        {hasPin === false ? (
          ""
        ) : (
          <div
            className={"pin-filter-close "}
            onClick={() => {
              if (window.FX && window.FX.UI) {
                window.FX.UI.closePopover();
              }
              this.props.onFilterClose && this.props.onFilterClose();
              this.props.context &&
                this.props.context.closeAlter &&
                this.props.context.closeAlter();
            }}
          >
            <i className={"icon-bsy-close-small "}></i>{" "}
          </div>
        )}

        {hasHeader ? (
          <div className="wrapper-title">
            <span className="title">{React.language("filter.condition")}</span>
            {hasRelation && filterTopSticky ? (
              <div className={"relation"}>
                <span className="rel-desc">
                  {React.language("filter.rel.tip")}
                </span>
                <BsySelect
                  theme={this.props.theme}
                  allowBlank={false}
                  searchable={false}
                  customCls={"cond-method"}
                  value={rel || "and"}
                  onStopEdit={(val) => {
                    this.setState({
                      rel: val,
                    });
                  }}
                  items={[
                    { value: "and", text: React.language("filter.rel.and") },
                    { value: "or", text: React.language("filter.rel.or") },
                  ]}
                />
                <span className="rel-desc">
                  {React.language("filter.rel.cond")}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {hasRelation && !filterTopSticky ? (
          <div className={"relation"}>
            <span className="rel-desc">{React.language("filter.rel.tip")}</span>
            <BsySelect
              theme={this.props.theme}
              allowBlank={false}
              searchable={false}
              customCls={"cond-method"}
              value={rel || "and"}
              onStopEdit={(val) => {
                this.setState({
                  rel: val,
                });
              }}
              items={[
                { value: "and", text: React.language("filter.rel.and") },
                { value: "or", text: React.language("filter.rel.or") },
              ]}
            />
            <span className="rel-desc">
              {React.language("filter.rel.cond")}
            </span>
          </div>
        ) : (
          ""
        )}

        <div className="pane">
          <div className="filter-list">
            {this.props.hasAppField ? this.renderAppField() : ""}

            {fields.map((field) => {
              // let fieldex = { ...field };
              let fieldex = this.toFilterOption(field);
              return this.createFilterItem(fieldex);
            })}
          </div>
          {(this.props.hasAppField && appId && entryId) ||
          !this.props.hasAppField ? (
            <BsyIconBtn
              iconName={"icon-bsy-add"}
              text={React.language("filter.addCondition")}
              click={(e) => {
                e.stopPropagation();
                let config = {
                  forms: this.props.forms,
                  entryList: this.state.entryList,
                  fields: [...this.state.fields], //fieldsFilter,
                  onStopEdit: (val) => {
                    this.setState(
                      {
                        fields: val,
                      },
                      () => {
                        this.getDefaultCache();
                      }
                    );
                  },
                };
                let that = this;

                BsyMsgBubble({
                  anchor: e.currentTarget,
                  contentHTML: (ref) => {
                    return (
                      <BsyFieldsSelectPane {...config}></BsyFieldsSelectPane>
                    );
                  },
                  text4Cancel: null,
                  text4Ok: null,
                  theme: this.props.theme,
                  minWidth: 200,
                  // width: 230,
                  contentPadding: 0,
                  edge: 200,
                  hAdjust: 72,
                  dockPosition: filterTopSticky ? "left" : "right",
                  onClose: function () {
                    that.setState({});
                    return !1;
                  },
                });
              }}
            />
          ) : (
            ""
          )}
        </div>

        <div className="footer">
          <BsyIconBtn
            text={React.language("filter")}
            mode={window.mode + " blue"}
            click={(e) => {
              this.props.onFilter && this.props.onFilter(this.getValue());
            }}
          />
          <BsyIconBtn
            // iconName={'icon-clear'}
            text={React.language("clear")}
            mode={window.mode + " clear "}
            click={(e) => {
              this.reset();
            }}
          />
        </div>
      </div>
    );
  }
}
